<div class="container-fluid">
  <h4 class="pt-3">Welcome to the Forefront Telecare Provider Portal!</h4>

  <ul class="list-group w-25">
    <li class="list-group-item" [routerLinkActive]="['active']">
      <a class="list-group-item-action" [routerLink]="routes.MyFacilities">View My Facilities</a>
    </li>
  </ul>
</div>
